module.exports = __webpack_public_path__ + "static/media/inkscape.78bdbe23.svg";